function toggleFilter() {
    let x = document.querySelector(".sq-filter-main");
    if (x) x.classList.toggle("opening");
}
function toggleClass() {
    let y = document.querySelector(".sq-filter-main");
    if (y) y.classList.remove("opening");
}
function removeClass() {
    let z = document.querySelector(".sq-filter-main");
    if (z) z.classList.remove("opening");
}

window.sq = window.sq || {};

window.sq.initSearch = (store) => {
    store.search();
};

(function () {
    // The app may evaluate this asset again; bind theme listeners only once.
    if (window.sq.__hemproveThemeBound) return;
    window.sq.__hemproveThemeBound = true;

    function bindMobileSearch() {
        if (!window.matchMedia("(max-width: 767px)").matches) return;
        const input = document.getElementById("Search-In-Modal");
        if (!input) return;

        input.addEventListener("focusin", () => {
            const dropdown = document.querySelector(".sq-dropdown-body");
            if (dropdown) dropdown.style.maxHeight = "100%";
        });
        input.addEventListener("focusout", () => {
            const dropdown = document.querySelector(".sq-dropdown-body");
            if (dropdown) dropdown.style.maxHeight = "0px";
        });
    }

    // Retain the existing load boundary, also covering an already-loaded page.
    if (document.readyState === "complete") {
        bindMobileSearch();
    } else {
        window.addEventListener("load", bindMobileSearch, { once: true });
    }

    setTimeout(() => {
        const filter = document.querySelector(".sq-filter-main");
        const container = document.querySelector(".sparq-container");
        if (filter) filter.style.visibility = null;
        if (container) container.style.visibility = null;
    }, 200);

    window.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            const footer = document.querySelector("footer");
            if (footer) footer.click();
        }
    });
})();
